import { render, staticRenderFns } from "./AutomatedText.vue?vue&type=template&id=f22f6c78&scoped=true&lang=pug"
import script from "./AutomatedText.vue?vue&type=script&lang=js"
export * from "./AutomatedText.vue?vue&type=script&lang=js"
import style0 from "./AutomatedText.vue?vue&type=style&index=0&id=f22f6c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22f6c78",
  null
  
)

export default component.exports